export const AN_STATUS_META = {
  nouveau: { label: "Nouveau", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  analyse: { label: "En cours d'analyse", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  planifiee: { label: "Intervention planifiée", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  en_intervention: { label: "En cours d'intervention", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  resolu: { label: "Résolu", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  clos_sans: { label: "Clôturé sans intervention", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const W_STATE_META = {
  valide: "bg-emerald-50 text-emerald-700 border-emerald-200",
  proche: "bg-amber-50 text-amber-700 border-amber-200",
  depassee: "bg-rose-50 text-rose-700 border-rose-200",
  sans_echeance: "bg-slate-100 text-slate-600 border-slate-200",
  none: "bg-slate-100 text-slate-500 border-slate-200",
};

export const ANOMALY_FLAG = "Anomalie signalée — à vérifier";

export function AnStatusBadge({ status, label, testId }) {
  const m = AN_STATUS_META[status] || AN_STATUS_META.nouveau;
  return <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${m.cls}`} data-testid={testId}>{label || m.label}</span>;
}

export function addMonths(iso, months) {
  if (!iso || !months) return "";
  const [y, m, d] = iso.split("-").map(Number);
  const t = new Date(Date.UTC(y, m - 1 + Number(months), 1));
  const last = new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() + 1, 0)).getUTCDate();
  t.setUTCDate(Math.min(d, last));
  return t.toISOString().slice(0, 10);
}

export const schedLabel = (s, fmt) => !s?.planned_start ? null
  : `${fmt(s.planned_start)}${s.all_day ? " · journée entière" : s.start_time ? ` à ${s.start_time}` : ""}${s.planned_end && s.planned_end !== s.planned_start ? ` → ${fmt(s.planned_end)}` : ""}`;
